import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OutgoingStudentGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
      if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name') &&
          JSON.parse(localStorage.getItem('epas_user')).roles[i]['role_name'] === 'OUTGOING_STUDENT') {
        return true;
      }
    }
    this.router.navigate(['no-access']);
    return false;
  }
}
